import React from "react";
import AddressCard from "../AddressCard/AddressCard";
import useFetch from "../../hooks/useFetch";
import { getToken } from "../../helpers";

const ListAddress = () => {
  const { data, loading, error } = useFetch(`/user-addresses?populate=*`, getToken());

  return (
    <div className="row">
      {loading
        ? "loading"
        : data?.map((item) => <AddressCard item={item} key={item.id} />)}
    </div>
  );
};

export default ListAddress;
